import {LANG, MEMBERSHIP_FEE_CENTS} from './Config';
import {translations} from './translations';
import {THEME} from './theme';
import {formatPrice} from './currency';

// Format de date affiché à l'utilisateur (DatePicker, rendu texte).
// Le format de stockage / d'envoi à l'API reste 'DD/MM/YYYY' — normaliser dans
// les handlers (cf. DateOpen.selectDate, FormRegister.onChangeDateNaissance).
export const DATE_FORMAT = LANG === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
export const DATE_FORMAT_SHORT = LANG === 'en' ? 'MM/DD/YY' : 'DD/MM/YY';
export const DATE_FORMAT_API = 'DD/MM/YYYY';

const themeVars = {
    year: new Date().getFullYear(),
    brand: THEME.brand,
    email: THEME.email,
    phoneDisplay: THEME.phone.display,
    phoneTel: THEME.phone.tel,
    urlSite: THEME.urls.site,
    urlPrivacy: THEME.urls.privacy,
    urlTerms: THEME.urls.terms,
    urlLegal: THEME.urls.legal,
    urlSecurity: THEME.urls.security,
    urlInternalRules: THEME.urls.internalRules,
    urlVolunteerPassport: THEME.urls.volunteerPassport,
    urlAppointment: THEME.urls.appointment,
    urlHelp: THEME.urls.help,
    bankAddressLine1: THEME.bank.addressLine1,
    bankAddressLine2: THEME.bank.addressLine2,
    bankAddressLine3: THEME.bank.addressLine3,
    bankIban: THEME.bank.iban,
    bankBic: THEME.bank.bic,
    bankCheckPayee: THEME.bank.checkPayeeName,
    membershipFee: formatPrice(MEMBERSHIP_FEE_CENTS / 100),
};

export function t(key, vars) {
    const path = key.split('.');
    const get = (lang) => path.reduce((acc, k) => (acc == null ? acc : acc[k]), translations[lang]);
    let str = get(LANG);
    if (str == null) str = get('fr');
    if (str == null) str = key;
    const merged = vars ? {...themeVars, ...vars} : themeVars;
    Object.keys(merged).forEach((v) => {
        str = str.split('{' + v + '}').join(merged[v]);
    });
    return str;
}
